export const ORDER_OPTIONS = [
  { value: "price asc", label: "Precio menor" },
  { value: "price desc", label: "Precio mayor" },
  { value: "name asc", label: "Nombre" },
  { value: "content.featured desc", label: "Destacados" },
  { value: "date_created desc", label: "Agregados recientemente" },
];
